import { useFile } from "#src/hooks/useFile";
import {
  Button,
  Dialog,
  FileUploadInput,
  Form,
  TextInput,
  useForm,
  useToast,
} from "@validereinc/common-components";
import {
  RecordDomain,
  RecordValueType,
  RecordValueUpdateType,
} from "@validereinc/domain";
import React, { useEffect } from "react";

export const AddRecordNoteDialog = ({
  isOpen,
  onClose,
  recordId,
  recordValue,
}: {
  isOpen: boolean;
  onClose: () => void;
  recordId: string;
  recordValue?: RecordValueType;
}) => {
  const noteForm = useForm({});
  const { handleFileUpload, handleFileDownload } = useFile();
  const { toast } = useToast();

  const handleSubmit = async () => {
    if (!recordId || !recordValue?.measurement_type) {
      return;
    }

    const noteFormValues = noteForm.getValues();
    const note = noteFormValues?.note?.trim();

    const body = {
      measurement_unit: recordValue?.measurement_unit,
      configuration: recordValue?.configuration,
      ...(note ? { note } : {}),
    } as RecordValueType;

    const file = noteFormValues?.attachment?.[0];
    if (file) {
      body.attachment_filename = file.name;
      body.attachment_ref = file.ref;
    }

    try {
      await RecordDomain.recordValue.update(
        {
          recordId,
          measurementType: recordValue?.measurement_type,
        },
        body as RecordValueUpdateType
      );
      toast.push({
        intent: "success",
        description: "Success!",
      });
      onClose?.();
    } catch (err) {
      console.error(err);
      toast.push({
        intent: "error",
        description: "Unable to update record configuration",
      });
    }
  };

  useEffect(() => {
    noteForm.reset();
  }, [isOpen]);

  return (
    <Dialog
      title="Include Note"
      isOpen={isOpen}
      onClose={onClose}
      actionRow={[
        <Button
          onClick={noteForm?.handleSubmit(handleSubmit)}
          variant="primary"
          disabled={noteForm?.formState.isSubmitting}
          key="done-button"
        >
          Done
        </Button>,
      ]}
    >
      <Form {...noteForm}>
        <TextInput
          name="note"
          label="Note"
          isRequired={false}
        />

        <FileUploadInput
          name="attachment"
          id="attachment"
          label="Attachment"
          placeholder="You can drag a file here to use as an attachment"
          isRequired={false}
          allowMultiple={false}
          uploadFile={handleFileUpload}
          downloadFile={handleFileDownload}
        />
      </Form>
    </Dialog>
  );
};
